import React from 'react';
import { defineMessages } from 'react-intl';

import ReuseableGridButton from '../../../components/grid-header/reusable-grid-button';
import ModalPortal from '../../../components/modal-portal';
import { ExportFulfillmentsContainer } from '../../../components/modals/export-records-new-modal/containers/export-fulfillments-container';
import { useDataExportFeatureGate } from '../../../feature-gates/use-data-export-feature-gate';
import { useModal } from '../../../hooks/use-modal';

const messages = defineMessages({
  buttonText: {
    description: 'Fulfillments Grid Export Button text',
    defaultMessage: 'Export',
    id: 'LZ3VEr',
  },
});

/**
 * @returns {React.JSX.Element}
 */
export const ExportFulfillmentsButtonExtended = () => {
  const { open, isOpen, close } = useModal();
  const { isFeatureEnabled, disabledMessage } = useDataExportFeatureGate();

  return (
    <>
      <ReuseableGridButton
        actionHandler={open}
        disable={!isFeatureEnabled}
        hasTooltip={Boolean(disabledMessage)}
        messageDescriptor={messages.buttonText}
        theme='tertiary'
        tooltipMessageDescriptor={disabledMessage}
      />
      {isOpen ? (
        <ModalPortal onClose={close}>
          <ExportFulfillmentsContainer onClose={close} onOpen={open} />
        </ModalPortal>
      ) : null}
    </>
  );
};
